import React, { Fragment } from 'react';
import AfasFormField from './AfasFormField';
import { formatWtfNl } from '../utils/formatWtf';

/** Bluebox shows WTF with 5 decimal places (e.g. 0,00000). */
const WTF_DISPLAY_FIELDS = new Set(['wtfAfwezige', 'wtfAfas']);

const groupInlineFields = (fields) => {
    const groups = [];
    let index = 0;

    while (index < fields.length) {
        const field = fields[index];
        if (field.col === 'main' && fields[index + 1]?.col === 'inline') {
            groups.push({
                type: 'row',
                fields: [field, fields[index + 1]],
            });
            index += 2;
        } else {
            groups.push({ type: 'single', fields: [field] });
            index += 1;
        }
    }

    return groups;
};

const displayValue = (fieldId, value) => {
    if (WTF_DISPLAY_FIELDS.has(fieldId)) {
        // empty / null / 0 → 0,00000 (Bluebox parity)
        return formatWtfNl(value === '' || value === null || value === undefined ? 0 : value, 5);
    }

    if (value === null || value === undefined || value === '') {
        return '';
    }

    return String(value);
};

const isDisplayPair = (fields) =>
    fields.every(
        (field) =>
            field.readOnly
            && field.type !== 'radio'
            && field.type !== 'checkbox'
            && field.type !== 'select',
    );

const AfasVerzoekFields = ({ fields, values = {}, onFieldChange, compact = true }) => {
    const groups = groupInlineFields(fields);

    return (
        <div
            className={`afas-verzoek-fields${compact ? ' clooser-controls--compact' : ''}`}
        >
            {groups.map((group) => (
                <Fragment key={group.fields.map((f) => f.id).join('-')}>
                    {group.type === 'row' && isDisplayPair(group.fields) ? (
                        <>
                            <span className="afas-verzoek-fields__label">
                                {group.fields[0].label}
                            </span>
                            <span className="afas-verzoek-fields__value">
                                {displayValue(group.fields[0].id, values[group.fields[0].id])}
                            </span>
                            <span className="afas-verzoek-fields__inline-label">
                                {group.fields[1].label}
                            </span>
                            <span className=" afas-verzoek-fields__inline-value ms-3">
                                {displayValue(group.fields[1].id, values[group.fields[1].id])}
                            </span>
                        </>
                    ) : (
                        <AfasFormField
                            field={group.fields[0]}
                            value={values[group.fields[0].id]}
                            onChange={
                                onFieldChange
                                    ? (value) => onFieldChange(group.fields[0].id, value)
                                    : undefined
                            }
                            compact={compact}
                        />
                    )}
                </Fragment>
            ))}
        </div>
    );
};

export default AfasVerzoekFields;
